import {svgIconWrapper} from '../svg-icon-wrapper';

import MarketingAutomation from './icon-marketing-automation.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <MarketingAutomation {...validProps} />;
}

SvgComponent.iconName = 'marketing-automation';

export const MarketingAutomationIcon = svgIconWrapper(SvgComponent);
